<template>
  <div class="flex">
    <div v-if="loading" class="relative w-full h-full" style="height: 320px">
      <loader dark />
    </div>
    <div v-if="!loading" class="w-full h-full text-white">
      <div class="w-full h-full text-white p-6">
          <gd-modal
            name="add-preset-modal"
            :title="$t('frontend_add_new_preset')"
            width="50%"
          >
            <div class="flex flex-col px-4">
              <div class="mt-4">
                <div class="-mt-4">
                  <div class="flex flex-row w-full">
                    <div class="w-full mt-4 mx-4">
                      <label
                        class="font-semibold text-sm text-grey-700 mb-2 text-left"
                        >{{ $t('frontend_groovemail_forms_new_preset_select_base') }}</label
                      >
                      <select
                        class="w-full h-10 outline-none text-dark rounded-lg px-4 border border-grey-200"
                        v-model="presetToClone"
                        @change="setPresetName"
                      >
                        <option :value="null">
                          {{ $t('frontend_builder_add_page_menu_start_from_scratch') }}
                        </option>
                        <optgroup label="Clone">
                          <option
                            v-for="preset in presets"
                            :key="preset.id"
                            :value="preset"
                            :data-name="preset.name"
                          >
                            {{ preset.name }}
                          </option>
                      </optgroup>
                      </select>
                    </div>
                    <div class="w-full mt-4 mx-4">
                      <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_preset_name') }}</label>
                      <div class="flex flex-row w-full">
                        <div class="w-full">
                          <text-input
                            variant="base"
                            v-model="presetName"
                            :placeholder="$t('frontend_preset_name')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-row w-full my-6 justify-end px-4">
                <gd-button
                  variant="primary"
                  class="font-semibold"
                  size="auto"
                  @click="addPreset"
                >
                  {{ $t('frontend_add') }}
                </gd-button>
              </div>
            </div>
        </gd-modal>
        <confirm-modal
          :ref="`confirmation-box-delete-preset`"
          :name="`confirmation-box-delete-preset`"
          :buttonText="$t('frontend_delete')"
          :cancelText="$t('frontend_cancel')"
          :confirm-message='`${$t("frontend_groovemail_template_fields_delete_confirm")} "${presetToDelete?.name}" ${$t("frontend_groovemail_preset")}`'
          @confirm="deletePreset(true)"
        />
        <div
          v-for="(item, index) in presets"
          :key="index"
          :class="{'mailform-sidebar-loop-group': presets.length > 2}"
          class="mailform-sidebar-loop"
        >
          <component
            :is="tag"
            :item="item"
            :activeElement="activePreset"
            @deleteElement="openDeletePresetModal"
            @activateElement="activatePreset"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import Loader from '@groovepages/gd-ui-kit/components/Loader';
import tag from './tag';

export default {
  name: 'PageMenu',
  data() {
    return {
      loading: true,
      tag,
      presetToDelete: null,
      presetToClone: null,
      presetName: this.$t('frontend_new_preset'),
    };
  },
  computed: {
    ...mapState({
      presets: state => state.forms.presets.filter(preset => preset.form_id === null || preset.form_id === undefined),
    }),
    ...mapGetters({
      activePreset: 'forms/activePreset',
    }),
  },
  components: {
    Loader,
    ConfirmModal,
  },
  methods: {
    setPresetName() {
      if (this.presetToClone) {
        this.presetName = `${this.presetToClone.name} ${this.$t('frontend_clone')}`;
        return;
      }
      this.presetName = this.$t('frontend_new_preset');
    },
    async activatePreset(item){
      await this.$store.dispatch('forms/setActivePreset', item.id);

      // reset the style change flag
      this.$store.dispatch('forms/setIsStyleChanged', false);
    },
    async openDeletePresetModal(item) {
      this.presetToDelete = item;
      this.$refs[`confirmation-box-delete-preset`].open();
    },
    async deletePreset(confirmed) {
      if (confirmed) {
        this.$store.dispatch('forms/deletePreset', this.presetToDelete);
      }
      this.presetToDelete = null;
    },
    async addPreset() {
      this.$store.dispatch('forms/addPreset', { preset: this.presetToClone, name: this.presetName });
      this.presetToClone = null;
      this.$root.$emit('modal-close', 'add-preset-modal');
    },
    showLoader() {
      this.loading = true;
    },
    hideLoader() {
      setTimeout(() => {
        this.loading = false;
      }, 100);
    },
  },
  mounted() {
    this.hideLoader();
  },
};
</script>
<style lang ="scss">
.customizable-tooltip{
  display: none;
  &::before{
    content: '';
    background: var(--brand-secondary-darker);
    top:13px;
    position: absolute;
    left: 0px;
    margin-left: -10px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--brand-secondary) transparent transparent;
    transform: rotate(90deg);
  }
  
  &-wrapper{
    left: 23%;
    top: 27px;
  }
}
.showInfo:hover + .customizable-tooltip{
  display: block;
  top: -7px;
  padding: 0px 8px;
  left: 26px;
  width: 228px;
  font-size: 12px;
  background: var(--brand-secondary);
}
.showInfo{
  svg{
    stroke: #989ab2 !important;
    fill: none;
  }
}
</style>
